module.exports = __webpack_public_path__ + "static/media/covi_ppe_eye_pro.924e2420.png";